import { Link } from 'react-router-dom';
import { ArrowRight, TrendingUp, DollarSign, Shield, Settings, LandPlot, Users, FileCheck } from 'lucide-react';

const services = [
  {
    icon: TrendingUp,
    title: 'Revenue System Development',
    description: 'Build revenue ecosystems that maximize burial volume, optimize pricing, and create diversified income streams.',
  },
  {
    icon: DollarSign,
    title: 'Pre-Need Sales Architecture',
    description: 'Design pre-need programs generating predictable revenue years ahead. Develop agent networks and commission structures.',
  },
  {
    icon: Shield,
    title: 'Insurance Distribution Strategy',
    description: 'Navigate insurance-backed preneed contracts with compliant structures that protect families while generating revenue.',
  },
  {
    icon: Settings,
    title: 'Operational Modernization',
    description: 'Modernization focused on operational reliability, record integrity, and sustainable margin improvement.',
  },
  {
    icon: Settings,
    title: 'Technology & Automation',
    description: 'Implement technology solutions that reduce costs, improve accuracy, and enhance the family experience.',
  },
  {
    icon: FileCheck,
    title: 'Regulatory & Audit Oversight',
    description: 'Ensure compliance with state regulations, trust requirements, and financial reporting standards.',
  },
  {
    icon: LandPlot,
    title: 'Land Expansion & Entitlement',
    description: 'Identify opportunities for cemetery expansion. Navigate zoning to add long-term asset value.',
  },
  {
    icon: Users,
    title: 'Board & Governance Alignment',
    description: 'Work with volunteer boards to establish clear strategic direction and accountability frameworks.',
  },
];

export default function Services() {
  return (
    <div>
      {/* Hero */}
      <section className="bg-slate-900 text-white py-12 md:py-16">
        <div className="container-custom">
          <div className="max-w-3xl">
            <h1 className="font-serif text-3xl md:text-4xl font-medium mb-4">
              Services
            </h1>
            <p className="text-lg text-gray-300">
              Operational and strategic services designed to stabilize, scale, and 
              modernize cemetery and deathcare organizations.
            </p>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-content mx-auto">
            {services.map((service, index) => (
              <div 
                key={index}
                className="bg-gray-50 p-5 rounded-sm border-l-4 border-accent-600 hover:shadow-md transition-shadow"
              >
                <service.icon className="w-8 h-8 text-accent-600 mb-3" />
                <h3 className="font-serif text-lg font-medium text-slate-900 mb-2">
                  {service.title}
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed">
                  {service.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Engagement Models */}
      <section className="section-padding bg-gray-50">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center mb-10">
            <h2 className="section-heading">Engagement Models</h2>
            <p className="section-subheading mx-auto mt-3">
              All engagements begin with clear scope, defined deliverables, and agreed reporting structure.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 max-w-content mx-auto">
            {[
              { title: 'Fractional COO', desc: '6-18 months hands-on leadership' },
              { title: 'Revenue Diagnostic', desc: '90-day comprehensive assessment' },
              { title: 'Exit Advisory', desc: 'Position for sale or succession' },
              { title: 'Retainer', desc: 'Ongoing strategic guidance' },
            ].map((model, index) => (
              <div key={index} className="bg-white p-4 border border-gray-100">
                <h3 className="font-serif text-base font-medium text-slate-900 mb-1">
                  {model.title}
                </h3>
                <p className="text-slate-600 text-xs">
                  {model.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section-padding bg-slate-900 text-white">
        <div className="container-custom text-center">
          <h2 className="font-serif text-2xl font-medium mb-4">
            Discuss Your Organization's Needs
          </h2>
          <p className="text-gray-400 max-w-xl mx-auto mb-8">
            Every organization faces unique challenges. Let's discuss how targeted 
            executive leadership can drive measurable results.
          </p>
          <Link to="/contact" className="btn-primary">
            Schedule a Confidential Consultation
            <ArrowRight className="ml-2 w-5 h-5" />
          </Link>
        </div>
      </section>
    </div>
  );
}
